import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';
import { CSSClass, DataTransferType, DndEvent, DOMEvent } from './dom.constant';

@Directive({
  selector: '[akDroppable]',
})
export class DroppableDirective implements OnInit {
  @Output() dragLeave: EventEmitter<any>;
  @Output() dragEnter: EventEmitter<any>;
  @Output() onDrop: EventEmitter<any>;
  @Input() animated: boolean | undefined;

  constructor(private renderer: Renderer2, private el: ElementRef) {
    this.renderer.addClass(this.el.nativeElement, CSSClass.DROP_SLOT);
    this.dragLeave = new EventEmitter();
    this.dragEnter = new EventEmitter();
    this.onDrop = new EventEmitter();

    this.el.nativeElement.addEventListener(
      DOMEvent.DRAG_OVER,
      this.dragOverHandler.bind(this)
    );

    this.el.nativeElement.addEventListener(
      DOMEvent.DRAG_ENTER,
      this.dragEnterHandler.bind(this)
    );

    this.el.nativeElement.addEventListener(
      DOMEvent.DRAG_LEAVE,
      this.dragLeaveHandler.bind(this)
    );

    this.el.nativeElement.addEventListener(
      DOMEvent.DRAG_END,
      this.dragEndHandler.bind(this)
    );

    this.el.nativeElement.addEventListener(
      DOMEvent.DROP,
      this.dropHandler.bind(this)
    );
  }

  ngOnInit(): void {
    if (this.animated) {
      this.renderer.setStyle(
        this.el.nativeElement,
        'transition',
        'height 0.1s ease-in'
      );
    }
  }

  private dragOverHandler($event: DragEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
  }

  private dragEnterHandler($event: DragEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.dragEnter.emit();
    this.renderer.addClass(this.el.nativeElement, CSSClass.DRAG_ENTER);
  }

  private dragLeaveHandler($event: DragEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.dragLeave.emit();
    this.renderer.removeClass(this.el.nativeElement, CSSClass.DRAG_ENTER);
  }

  private dragEndHandler($event: DragEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.dragLeave.emit();
  }

  private dropHandler($event: DndEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.dragLeave.emit();
    this.renderer.removeClass(this.el.nativeElement, CSSClass.DRAG_ENTER);

    const dataTranfered = $event.dataTransfer.getData(DataTransferType.TEXT);
    if (dataTranfered) {
      this.onDrop.emit(JSON.parse(dataTranfered));
    } else {
      this.onDrop.emit();
    }
  }
}
